import { query } from './query';
import store from './store';
import { type History } from 'types/models';

export default class HistoryService {
   private static instance: HistoryService;
   private store = store;
   private query = query;

   constructor() {
      if (!HistoryService.instance) {
         HistoryService.instance = this;
      }

      // Service shall be instantiated only once, because otherwise the observable will be created for each service instance

      return HistoryService.instance;
   }

   setHistoryReference(storeName: History['storeName'], entityId: History['entityId'], footprintId: History['footprintId'] = null) {
      return this.store.update({ storeName, entityId, footprintId });
   }
}
